import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./RepresentativeForm.module.css";
import { InputBox, ValidatedEmailInput } from "@cpnw/ui";

export const RepresentativeForm = forwardRef(({ representativeFormData, onChange }, ref) => {
  const [isValid, setIsValid] = useState(true);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });
  const emailRef = useRef();
  // ✅ Expose `validateAllFields` method to parent
  useImperativeHandle(ref, () => ({
    validate: () => {
      const newErrors = {};

      const nameValue = representativeFormData.name;
      const emailValue = representativeFormData.email;
      if (!nameValue?.trim()) {
        newErrors.name = "Name is required.";
      }
      if (!emailValue?.trim()) {
        newErrors.email = "Email is required.";
      }
      
      setErrors(newErrors);
      if (Object.keys(newErrors).length > 0) return false;

      const isNameValid = Object.keys(newErrors).length === 0;
      const isEmailValid = emailRef.current?.validate() ?? false;

      const isFormValid = isNameValid && isEmailValid;
      setIsValid(isFormValid);

      return isFormValid;
    },
  }));

  const handleBlur = (field) => (e) => {
    const value = e.target ? e.target.value : e;
    if (!value?.trim()) {
      setErrors((prev) => ({
        ...prev,
        [field]: `${field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, " $1")} is required`,
      }));
    } else {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleChange = (field, value) => {
    const newData = {
      ...representativeFormData,
      [field]: value,
    };
    onChange(newData); // Always update
  };

  return (
    <div>
      <p className={classNames(styles.message)}>**Required</p>
      <div className={classNames(styles.container)}>
        <div className={classNames(styles.column)}>
          <InputBox
            className={styles.inputBoxRound}
            placeholder={"Representative Name"}
            value={representativeFormData.name || ""}
            // required={true}
            onChange={(e) => handleChange("name", e.target.value)}
            onBlur={handleBlur("name")}
            aria-invalid={!!errors.name}
            aria-describedby={errors.name ? "name-error" : undefined}
          />
          <p id="name-error" className={styles.errorMessage}>{errors.name}</p>
        </div>
        <div className={classNames(styles.column)}>
          <ValidatedEmailInput
            ref={emailRef}
            className={styles.inputBoxRound}
            value={representativeFormData.email}
            onChange={(val) => handleChange("email", val)}
            placeholder={"Representative Email"}
          // required={false}
          />
          <p id="email-error" className={styles.errorMessage}>{errors.email}</p>
        </div>
      </div>
    </div>
  );
});

RepresentativeForm.propTypes = {
  representativeFormData: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
